/** Session cache for pipeline poll results (LoadingUI + project list %). */

export const PIPELINE_POLL_CACHE_PREFIX = 'volugraph_poll_';
export const PIPELINE_POLL_CACHE_CLEARED_EVENT = 'pipeline-poll-cache-cleared';

export function pipelinePollStorageKey(captureId, projectId) {
  const p = projectId ? String(projectId) : '';
  return `${PIPELINE_POLL_CACHE_PREFIX}${p}::${captureId}`;
}

export function loadPipelinePollCache(captureId, projectId, expectedPhase = null, expectedRunEpoch = null) {
  try {
    const raw = sessionStorage.getItem(pipelinePollStorageKey(captureId, projectId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (expectedPhase === 'uploading') {
      if (parsed?.phase && parsed.phase !== 'uploading') {
        return null;
      }
      const stageIndex = Number(parsed?.stageIndex);
      if (Number.isFinite(stageIndex) && stageIndex >= 2) {
        return null;
      }
    }
    if (
      expectedRunEpoch != null
      && parsed?.runEpoch != null
      && Number(parsed.runEpoch) !== Number(expectedRunEpoch)
    ) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function savePipelinePollCache(captureId, projectId, data) {
  try {
    sessionStorage.setItem(pipelinePollStorageKey(captureId, projectId), JSON.stringify(data));
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearPipelinePollCache(captureId, projectId) {
  if (!captureId) return;
  try {
    sessionStorage.removeItem(pipelinePollStorageKey(captureId, projectId));
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(PIPELINE_POLL_CACHE_CLEARED_EVENT, {
      detail: { captureId, projectId: projectId ? String(projectId) : '' },
    }));
  }
}
